module.exports = {
  all: [
    {
      label: "Arial Regular",
      value: "Arial",
    },
    {
      label: "Verdana Regular",
      value: "Verdana",
    },
    {
      label: "Tahoma Regular",
      value: "Tahoma",
    },
    {
      label: "Trebuchet MS Regular",
      value: "TrebuchetMS",
    },
    {
      label: "Times New Roman Regular",
      value: "TimesNewRoman",
    },
    {
      label: "Georgia Regular",
      value: "Georgia",
    },
    {
      label: "Courier New Regular",
      value: "CourierNew",
    },
    {
      label: "Comic Sans MS Regular",
      value: "ComicSansMS",
    },
  ],
};
